/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $MultisigTransactionPayload = {
    type: 'any-of',
    contains: [{
        type: 'EntryFunctionPayload',
    }],
} as const;
